<template>
  <base-section id="shareholder-structure">
    <div
      data-aos="fade-up"
      data-aos-delay="50"
      data-aos-duration="1000"
      data-aos-easing="ease-in-out"
      data-aos-mirror="true"
      data-aos-once="false"
      data-aos-anchor-placement="top-center"
    >
      <base-section-heading
        color="grey lighten-2"
        title="Struktur Pemegang Saham"
      />
      <v-container class="text-justify">
        <p>
          <span style="font-weight: 400;"
            >Komposisi kepemilikan saham PT Asuransi Takaful Umum dimiliki oleh
            Koperasi Simpan Pinjam JASA (Kospin JASA) sebesar 90,48% dan Bahroji
            sebesar 9,52%.</span
          >
        </p>
        <img
          src="../../../src/assets/ChartPie.jpg"
          width="500"
          style="display: block; margin: 10px auto 10px; float: none; clear: both;"
        />

        <p>
          <span style="font-weight: 400;"
            >- Koperasi Simpan Pinjam JASA (Kospin JASA) <br /><br />Koperasi
            Simpan Pinjam JASA (Kospin JASA) merupakan koperasi yang dimiliki
            oleh para anggotanya dan dibentuk oleh sekelompok pengusaha kecil
            dan menengah pada tahun 1970-an. Kospin JASA didirikan dengan tujuan
            untuk menyediakan solusi pembiayaan dalam mengatasi keterbatasan
            akses permodalan bagi pelaku usaha kecil dan menengah, khususnya
            dalam memperoleh pinjaman sebagai modal usaha.<br /><br />
            Seiring dengan perkembangan usaha dan penguatan tata kelola
            perusahaan, Kospin JASA berperan aktif sebagai pemegang saham
            mayoritas dalam mendukung arah strategis, penguatan permodalan,
            serta penerapan tata kelola yang baik pada PT Asuransi Takaful Umum,
            guna mendorong pertumbuhan usaha yang berkelanjutan. <br /><br />
            - Drs. H. Bahroji, M.M.<br /><br />
            Beliau menjabat sebagai Komisaris Utama PT Asuransi Takaful Umum
            sejak tahun 2018 dan menjadi Wakil Bendahara Umum Koperasi Simpan
            Pinjam Jasa sejak tahun 2020. Beliau merupakan pemegang 9,52% saham
            di PT Asuransi Takaful Umum.<br /><br />
            Drs. H. Bahroji, M.M. lahir di Tegal, 4 Desember 1960. Beliau meraih
            gelar Sarjana Ilmu Sosial dan Ilmu Politik dari Universitas
            Pancasakti pada tahun 1988, dan gelar Magister di bidang Manajemen
            dari Universitas Jenderal Soedirman pada tahun 1998.<br /><br />
            Karirnya dimulai sebagai Kepala Divisi Treasury dan Pengembangan
            Usaha, Koperasi Simpan Pinjam Jasa (1987 - 2014), kemudian menjadi
            Bendahara II Koperasi Simpan Pinjam Jasa (2015 - 2020). Pada tahun
            2010 - 2020 menjadi Direktur Utama PT Jasa Investindo sekaligus
            Komisaris PT Jasa Utama Capital. Kemudian menjadi Direktur Utama PT
            Mega Surya Investa (2014 - 2021). Pada tahun 2014 hingga sekarang
            menjadi Direktur PT Texin Permata Husada. Menjadi Direktur Utama PT
            Jasa Prima Investa (2015 - sekarang).</span
          >
        </p>
      </v-container>
    </div>
  </base-section>
</template>

<script>
export default {
  name: "SectionAboutUsDetail",

  data: () => ({
    colour: ["#001F48", "#008493", "#3EC2D1", "#FF6600"],
    items: [
      {
        color: "primary",
        icon: "mdi-star",
        title: "Syarikat Takaful Indonesia",
        text: "PT Syarikat Takaful lndonesia (Takaful lndonesia) didirikan",
        date: "24 Februari 1994"
      },
      {
        color: "secondary",
        icon: "mdi-book-variant",
        title: "Takaful Umum",
        text: "PT. Asuransi Takaful Umum didirikan",
        date: "14 Desember 1994"
      },
      {
        color: "accent",
        icon: "mdi-airballoon",
        title: "Takaful Umum Run Off",
        text:
          "PT. Asuransi Takaful Umum berhenti melakukan kegiatan penjualan dikarenakan pemegang saham STMB tidak melanjutkan",
        date: "9 November 2016"
      },
      {
        color: "fourth",
        icon: "mdi-cash-multiple",
        title: "Kospin Jasa",
        text: "Kospin Jasa mengakuisisi kepemilikkan Takaful Umum dari STMB",
        date: "Maret 2018"
      },
      {
        color: "primary",
        icon: "mdi-gift",
        title: "Underwriting Surplus",
        text:
          "Takaful Umum membagikan Underwriting Surplus dengan total 3 Miliar Rupiah kepada peserta",
        date: "13 September 2018"
      }
    ]
  })
};
</script>
